import { createReducer, on } from '@ngrx/store';
import * as storesActions from './store-details-actions';
import * as fromStores from './store-details-state';

const initialState: fromStores.State = {isLoading: false, data: null};
export const reducer = createReducer(
  initialState,
  on(storesActions.LoadingStoreDetailsActions, (state) => {
    return {...state, isLoading: true};
  }),
  on(storesActions.CancelRequestStoreDetailsActions, (state) => {
    return {...state, isLoading: false};
  }),
  on(storesActions.ErrorStoreDetailsActions, (state) => {
    return {...state, isLoading: false};
  }),
   on(storesActions.StoreDetailsActions, (state, {data}) => {
    return {...state, isLoading: false, data};
  })
);
